import type { CashOutSportList, OneAuthenticationInfo } from './site';

export interface UserInfo {
	/** Asia Game */
	AG: number;
	/** EnableAllLive */
	AL: number;
	AccessToken: string | null;
	ActStatus: number;
	AdvantplayMiniStatus: number;
	AdvantplayStatus: number;
	AgentSite: string;
	AlivePlanList: Array<LoyaltyAlivePlan> | null;
	AllBet: boolean;
	BCredit: string;
	/** CanSeeBullFightingResult */
	BF: number;
	/** CanSeeBG */
	BG: number;
	/** CanSeeBBinLiveCasino */
	BLC: number;
	BaStatus: boolean;
	Bal: string;
	BankingUrl: string | null;
	BasketballMinesStatus: number;
	BasketballTowersStatus: number;
	BehaviorPromotionInfo: {
		HasRiskFreeEventPrivilege: boolean;
	},
	BetStake: string;
	BetterOdds: boolean;
	BettingMode: number;
	BonusCode: number | null;
	/** CanSeeColossusBet */
	CB: number;
	/** CustomerClass */
	CC: number;
	/** CanSeeCockFighting */
	CF: number;
	/** CasinoStatus */
	CGStatus: number;
	/** NeedToChangePassword */
	CHP: number;
	/** CasinoStatus.ProductStatus */
	CL: number;
	/** CanSeeCashOut */
	CO: number;
	COBasketBall: number;
	/** EnableCrossSelling */
	CS: boolean;
	/** CanSeeCrossSellingByRef */
	CSByRef: boolean;
	Cas: number;
	CanSeeAdvantPlayVendorLobby: number;
	CanSeeAllPinGoal: boolean;
	CanSeeESTwitchStreaming: number;
	CanSeeWinLossReport: boolean;
	CanSeeSportsLottery: boolean;
	Enable3RdProductResult: number;
	CashNoBonus: string | null;
	CashOutSportList: CashOutSportList;
	CreateDate: string;
	CricketLotteryStatus: number;
	CricketMinesStatus: number;
	CricketTowersStatus: number;
	/** Currency Name */
	Curr: string;
	/** Currency Id */
	CurrId: number;
	custBalance: CustBalance | null;
	CustSeq: number;
	DarkMode: boolean;
	/** DisableHKKMember */
	DHKK: number;
	DepositToken: string;
	DepositURL: string;
	ESportsLotteryStatus: number;
	EnableCustomerSurvey: boolean;
	EnableESportWeb: boolean;
	EnableExchangeTransfer: boolean;
	EnableLoyalty: boolean;
	EnableLoyaltyExchange: boolean;
	EnableMatchFeatureFilter: boolean;
	EnableOddsBoost: boolean;
	EnablePersonRecomBetDelay: boolean;
	EnablePersonRecomOddsPage: boolean;
	/** Booked bet */
	EnableLicBooked: boolean;
	EnableRewardSystem: boolean;
	EnableRewardMaintenance: boolean;
	EnableSingleWallet: boolean;
	Exchange: number;
	ExtendToken: string;
	Email: string;
	EdgeGaming: number;
	FggLiveCasino: number;
	FreeBetBannerEndDate: string;
	FreeBetRoundID: string;
	FunkyGames: number;
	/** QuickLink */
	GB: number;
	/** Balance.GivenCredit */
	GCredit: string;
	/** CanSeeGD */
	GD: number;
	/** CanSeeGDG */
	GDG: number;
	/** CanSeeGlobalGaming */
	GG: number;
	/** CanSeeGOF 財神爺 */
	GOF: number;
	GTCasino: number;
	/** HomePreferences */
	HP: number;
	HabaneroStatus: number;
	Happy5: number;
	HasShownBettingModePopup: boolean;
	HasShownGalaxyTutorial: boolean;
	HasVisitedGalaxy: boolean;
	/** memberInfo.CustID */
	ID: number;
	/** CanSeeION */
	ION: number;
	Indo4D: boolean;
	InpbetStake: string;
	/** for player in‐depth interview */
	IsCustomerDeepConversation: boolean;
	IsOffice: boolean;
	IsShowBonus: boolean;
	IsValidPromotionVoucherUser: boolean;
	JiliGamesStatus: number;
	JokerStatus: number;
	/** CanSeeKenoLottery */
	KL: number;
	Keno: number;
	/** LastBet */
	LB: number | null;
	/** CanBetLiveCasino */
	LCas: number;
	/** LuckyDrawList */
	LDW: number;
	/** CanSeeLeapGaming */
	LG: number;
	/** LastLogin */
	LLogin: string | null;
	/** LSportsToken */
	LSportsID: string;
	/** LastTransaction */
	LTran: string;
	Lang: string;
	LicenseeSiteSetting: LicenseeSiteSetting;
	LoginUserName: string;
	// 給前端用戶看的名稱
	DisplayUserName: string;
	LuxGamingBaccaratStatus: number;
	LuxGamingRouletteStatus: number;
	LuxGamingSicBoStatus: number;
	LuxGamingStatus: number;
	LuxGamingXocDiaStatus: number;
	LogId: string;
	/** CanSeeMyanmarOdds */
	MR: number;
	/** CanSeeMuayThai */
	MT: number;
	MXG: number;
	MaxGame: number;
	MicroGamingStatus: number;
	MiniStatus: number;
	/**
	 * Layout value, 0: card, 1: list
	 * @deprecated Use user.UserSetting.OddsPageLayoutType instead
	 */
	MobileVersion: number;
	/** CanSeeN7 */
	N7: number;
	NBALotteryStatus: number;
	/** CanSeeNumberGame */
	NG: number;
	/** Balance.NetPosition */
	NP: string | null;
	Name: string;
	NeedGotoDeposit: boolean;
	NewsCenterDomain: string;
	Niname: string;
	OType: number;
	OddsBoostMaxBet: string | null;
	OddsBoostTicketCount: number;
	OddsServerToken: string;
	OddsServerUrl: string;
	OperatorId: string;
	OneRng: number;
	/** balanceInfo.OutstandingTxn */
	OutSd: string;
	/** EnableParlayAll */
	PA: number;
	/** PasswordExpiryDate */
	PEdate: string;
	/** CanSeePokerGames */
	PG: number;
	PGSoftStatus: number;
	PPJPStatus: number;
	PPLiveCasino: number;
	PPStatus: number;
	Parlay5: number;
	PendingBonus: number;
	PromotionOddsBoostInfo: PromotionOddsBoostInfo;
	/** QuickBetStake */
	QBS: string;
	/** QuickLink */
	QK: number;
	QualifiedBonus: Array<object> | null;
	/** auth.CanSeeHorse || auth.CanSeeGreyhounds || auth.CanSeeHarness */
	RC: number;
	RNGJP: number;
	RefreshToken: string | null;
	RewardCurrentExp: number;
	RewardInfo: RewardInfo;
	RewardLevelUpExp: number;
	RewardVipLevel: number;
	SAGaming: number;
	/** CanSeeSabaClub */
	SC: boolean;
	/** CanSeeSuperLive */
	SL: number;
	/** ShowLogOut */
	SLOut: boolean;
	/** SmartLeagueSort */
	SLSort: boolean;
	SMP_1: boolean;
	SMP_2: boolean;
	SMPLive_1: boolean;
	SMPLive_2: boolean;
	/** CanSeeSoccarat */
	SOC: number;
	/** SmartSportSort */
	SSSort: boolean;
	/** CanSeeAESexy */
	SXG: boolean;
	/** OddsSort */
	SYT: number;
	SabaCoinWallet: SabaCoinWallet | null;
	SabaID: number;
	SabaName: string | null;
	SabaPWD: string | null;
	SabaPoints: string;
	SabaSatausID: number;
	ShowBonusMsg: boolean;
	ShowRedEnvelope2021: boolean;
	SoccerMinesStatus: number;
	SoccerTowersStatus: number;
	SpadeGaming: number;
	SportsQuickBetStake: number;
	Spread: number;
	SubsidiaryOpratorId: string;
	SyncCasino: boolean;
	/** SyncTime */
	SysT: string;
	/** CanSeeTableGame */
	TG: number;
	/** CanSeeTimeMachine */
	TM: number;
	/** CanSeeTimeMachineHDP */
	TMHDP: number;
	/** TimeMachineInterval */
	TMINR: number;
	/** EnableTodayWithLive */
	TWL: number;
	TennisLotteryStatus: number;
	/** canSeeTransferFundCallBack */
	TransFd: boolean;
	TsId: string;
	/** GetIsIIBCUser */
	UT: number;
	UseEdsOddsServer: boolean;
	UseNewCasinoRoyale: number;
	UseOddsServer: boolean;
	UseOldResult: boolean;
	UseOldStatement: boolean;
	UserReject: boolean;
	UserSetting: UserSetting;
	VBStatus: number;
	VGaming: boolean;
	VGamingMobi: boolean;
	/** CanSeeVirtualSports("180") */
	VR: number;
	/** CanSeeVirtualGames */
	VRG: boolean;
	/** CanSeeBRVWorldSport */
	VRS: number;
	/** CanSeeBRVSAsianCup */
	VSAC: number;
	/** CanSeeBRVSChampionsCup */
	VSCC: number;
	/** CanSeeBRVSEuroCup */
	VSEC: number;
	/** CanSeeBRVSEnglishPremier */
	VSEP: number;
	VenderMemberId: string;
	/** CloseVsPlace */
	VsPlace: boolean;
	/** CanSeeWatchBet */
	WB: number;
	/** CanSeeWMLiveCasino */
	WM: number;
	/** CanBetYeeBet */
	YeeBet: boolean;
	CanSeeCloudRockStreaming: boolean;
	FromCountry: string;
	IsShouldClearDomain: boolean;
	ApiBackendUrl: string;
	Ip: string;
	PopularBettingExchangeRate: number;
	JackPotExchangeRate: number;
	VSTournament: boolean;
	CustomInfo5: string;
	VirtuallySoccer: number;
	VirtuallySoccerSportsMenu: boolean;
	EnableSBRWidget: boolean;
	CanSeeAvailableFunds: boolean;
	CanSeePendingFunds: boolean;
};

export interface UserSetting {
	EnableQuickStake: boolean,
	QuickStake: string,
	EnableCrossSelling: boolean,
	EnableDarkMode: boolean,
	EventSortType: number,
	EnableAISportSort: boolean,
	OddsPageLayoutType: number,
	QuickBetStake: number,
	HasShownFeatureIds: string,
	BettingMode: number,
	CommonColumn1: string,
	CommonColumn2: string,
	CommonColumn3: string,
	OddsType: number,
	LayoutMode: number,
	BetStake: number,
	DefaultLanguage: string,
	OddsSort: number,
	SportSort: string,
	SportsBetTypesSetting: PreferredMainBetType | null;
	BetterOdds: boolean,
	AutoRefresh: boolean,
	ShowScoreMap: boolean,
	ShowLiveCasino: boolean,
	CusStake1: number,
	CusStake2: number,
	MarketType: number,
	BetslipStyle: number,
	Recommendation: boolean,
	AutoAcceptAnyOddsForParlayBets: boolean
};

/**
 * for HasShownFeatureIds from UserSetting
 * @description 後續若調整彈窗內容，務必更改 featureId 才會重新顯示
 */
export const PopUpFeatureId = {
	/** Galaxy 新手教學 */
	GalaxyTutorial: '01', // 尚未套用
	/** 新用戶引導設定 (使用 '03' 接續 BetSlipV2 改版通知的 '02') */
	BettingMode: '03',
	/** Mars 改版通知 */
	MarsRevisionNotice: '04',
	/** BettypeModeNotice: */
	BettypeModeNotice: '05',
	BettypeModeNew: '06',
	BetBuilderPlusTutorial: '07',
} as const;

export type PopUpFeatureIdType = typeof PopUpFeatureId[keyof typeof PopUpFeatureId];

export interface SabaCoinWallet {
	AvailableFund: string;
	PendingFund: string;
	ActStatus: number;
};

export interface LicenseeSiteSetting {
	DisplayCurrencySymbol: string;
	DisplayCurrencyName: string;
	ExtendSessionUrl: string;
	IsShouldDoDomainDetector: boolean;
	EnableGlobalDomainDetector: boolean;
	EnableBoxingPromotion: boolean;
	OriginalRefer?: string;
	EnablePluginStreamerSources: Array<number>;
	EnableNbaPlayoffsSurvey: boolean;
	EnableVirtualSteepleChaseBanner: boolean;
	EnableBetbyEsoccer: boolean;
	EnableBetbyBasketball2K: boolean;
}

export interface RewardInfo {
	CurrentExp: number;
	EnableRewardSystem: boolean;
	IsVipMax: boolean;
	LevelUpExp: number;
	StreamerRewardId: number;
	VipLevel: number;
	SabaCoin: number;
	CanSignIn: boolean;
	PromoteBookedBet?: boolean;
	EnableRewardRiskFreeBet: boolean;
	EnableRewardNicknameChange: boolean;
	EnableRewardNewRiskFreeBet: boolean;
}

export interface LoyaltyAlivePlan {
	PlanID: number;
	Status: number;
}

export interface CustBalance {
	Amount: number;
	Cash: number;
	finalbalance: number;
	LockedAmt: number;
}

export interface UserSettingsData {
	betInfo: {
		betAcceptBetter?: boolean
		betDefaultStake?: string
		// events sorting name?: Normal Sorting or Sort by Time
		betOddsSort?: string
		// events sorting id 1 or 2  
		betOddsSortID?: number
		/** quick stake - stake 1 */
		betQ1?: string
		/** quick stake - stake 2 */
		betQ2?: string
		/** quick stake - stake 3 */
		betQ3?: string
		/** quick stake - 1: enabled, 0: disabled */
		betQBet?: number
		betStakeID?: string
		betStakeValue?: number
	}
	displayInfo: {
		disLanID?: string
		disLanguage?: string
		disOddsType?: string
		disOddsTypeKey?: string
		openDarkMode?: boolean
	}
}

export interface VisitorInfo extends OneAuthenticationInfo {
	AccessToken?: string;
	OddsServerToken?: string;
	OddsServerUrl?: string;
	ApiBackendUrl?: string;
	IsShouldClearDomain?: boolean;
}

export interface AccountTokenData {
	Token: string;
	UserName: string;
	SiteName: string;
}

export interface LoginCheckInData {
	LogId: string;
	RedirectUrl: string;
}

export interface AccessTokenData {
	AccessToken: string;
	CountryShort: string;
	SessionId: string;
}

export interface PromotionOddsBoostInfo {
	EnablePromotionOddsBoost: boolean;
	EnableAffPromotionOddsBoost: boolean;
	GiftOddsBoostTicketCount: number;
	GiveTime: string;
	Deadline: string;
	IsNotify: boolean;
	HasNotify: boolean;
}

export enum PreferredSoccerMainBetType {
	OneXTwo = 1,
	Handicap = 2,
	OverUnder = 3,
}

export type PreferredMainBetType = {
	1: PreferredSoccerMainBetType;
	997: PreferredSoccerMainBetType;
	9994: PreferredSoccerMainBetType;
	9995: PreferredSoccerMainBetType;
};